import { gql } from "@apollo/client";

export default gql`
  query aiSkillsOverview($organizationId: Int) {
    aiSkillsOverview(organizationId: $organizationId) {
      __typename
      ... on SkillNode {
        id
        name
        slug
        description
        body
        visibility
        canEdit
        canArchive
        overridesSource
        isScheduled
      }
      ... on PlatformSkillType {
        name
        slug
        description
        body
        visibility
        canEdit
        canArchive
        overridesSource
        isScheduled
      }
    }
  }
`;
